import { render } from "./tokenrequest.vue?vue&type=template&id=7829a2bc&scoped=true&ts=true"
import script from "./tokenrequest.vue?vue&type=script&lang=ts"
export * from "./tokenrequest.vue?vue&type=script&lang=ts"

import "./tokenrequest.vue?vue&type=style&index=0&id=7829a2bc&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7829a2bc"]])

export default __exports__